/**
 * Responsible for storing the data that related to the job detail.
 */

import { store, action, observable } from '~/common/mobx.decorator'
import { notifyStore } from '../notify.store'
import { apolloClient, GET_JOB_DETAIL_QUERY, LIKE_DISLIKE_JOB_MUTATION } from '~/common/apollo'
import { redirectEventTrackingBookMark } from '~/common/helpers/bookMark.helper'
import { authStore } from '../auth.store'

@store()
class JobDetailStore {
	@observable currentJob = null
	@observable showError = false
	@observable job = null

	@action
	updateJobInfo = (newJobInfo) => {
		this.job = { ...newJobInfo }
	}

	/**
	 *
	 * @param {*} id - The job id
	 */
	@action
	fetchJobDetail = async (id) => {
		try {
			this.showError = false

			const response = await apolloClient.query({
				query: GET_JOB_DETAIL_QUERY,

				variables: { id },
			})

			const job = response.data?.job

			if (!job) {
				this.showError = true
			}

			this.updateJobInfo(job)

			return job
		} catch (error) {
			notifyStore.error(error.message)
			this.showError = true
		}
	}

	@action
	setFavorite = () => {
		// Set the job as favorite
	}

	@action
	requestInterview = () => {
		// Request an interview for the job
	}

	@action
	onClickFavorite = async (values) => {
		const { jobId, action } = values?.variables

		try {
			await apolloClient.mutate({
				mutation: LIKE_DISLIKE_JOB_MUTATION,
				variables: {
					jobId: jobId,
					action: action,
				},
			})
			if (action) {
				await redirectEventTrackingBookMark(action, {
					job_id: jobId,
					is_bookmarked: !action,
					worker_email: authStore.workerEmail,
				})
			}

			notifyStore.success('$MESSAGES.SUCCESSFUL')
		} catch (error) {
			notifyStore.error(error.message)
		}
	}
}

const jobDetailStore = new JobDetailStore()
export default jobDetailStore
